import { IManufacture } from 'src/app/shared/services/dealer.service';

export const NAMESPACE = 'PARAMS';
const INITIAL_STATE: AppParamState = {
  id: null,
  previousUrl: null,
  currentTab: 0,
  manufacturers: [],
  isShopCptEnabled: false,
  poNum: 0,
};

export const AppParamsActions = {
  INIT: `${NAMESPACE}.INIT`,
  SET_ID: `${NAMESPACE}.SET_ID`,
  SET_PREVIOUS_URL: `${NAMESPACE}.SET_PREVIOUS_URL`,
  SET_CURRENT_TAB: `${NAMESPACE}.SET_CURRENT_TAB`,
  KEEP_CURRENT_STATE: `${NAMESPACE}.KEEP_CURRENT_STATE`,
  UPDATE_ID_FROM_LS: `${NAMESPACE}.UPDATE_ID_FROM_LS`,
  SET_MANUFACTURERS: `${NAMESPACE}.SET_MANUFACTURERS`,
  SET_PO_NUM: `${NAMESPACE}.SET_PO_NUM`,
  UPDATE_PO_NUM_FROM_LS: `${NAMESPACE}.UPDATE_PO_NUM_FROM_LS`,
  SET_IS_SHOP_CPT_ENABLED: `${NAMESPACE}.SET_IS_SHOP_CPT_ENABLED`,
  UPDATE_IS_SHOP_CPT_ENABLED_FROM_LS: `${NAMESPACE}.UPDATE_IS_SHOP_CPT_ENABLED_FROM_LS`,
};

export function AppParamsReducer(
  state: AppParamState = INITIAL_STATE,
  action: any
) {
  const newState = { ...state };
  switch (action.type) {
    case AppParamsActions.INIT:
      return { ...INITIAL_STATE };
    case AppParamsActions.SET_ID:
      newState.id = action.payload;
      return newState;
    case AppParamsActions.SET_PREVIOUS_URL:
      newState.previousUrl = action.payload;
      return newState;
    case AppParamsActions.SET_CURRENT_TAB:
      newState.currentTab = action.payload;
      return newState;
    case AppParamsActions.KEEP_CURRENT_STATE:
      return newState;
    case AppParamsActions.UPDATE_ID_FROM_LS:
      newState.id = action.payload;
      return newState;
    case AppParamsActions.SET_MANUFACTURERS:
      newState.manufacturers = action.payload;
      return newState;
    case AppParamsActions.SET_PO_NUM:
      newState.poNum = action.payload;
      return newState;
    case AppParamsActions.UPDATE_PO_NUM_FROM_LS:
      newState.poNum = action.payload;
      return newState;
    case AppParamsActions.SET_IS_SHOP_CPT_ENABLED:
      newState.isShopCptEnabled = action.payload;
      return newState;
    case AppParamsActions.UPDATE_IS_SHOP_CPT_ENABLED_FROM_LS:
      newState.isShopCptEnabled = action.payload;
      return newState;
    default:
      return newState;
  }
}

export interface AppParamState {
  id?: number;
  previousUrl?: string;
  currentTab?: number;
  manufacturers?: IManufacture[];
  isShopCptEnabled?: boolean;
  poNum?: number;
}
